
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 3.326c-.924-1.32-2.762-1.667-4.082-.743L9.131 7.335 6.663 5.607A3.57 3.57 0 105.16 7.02l3.023 2.117-3.023 2.116a3.571 3.571 0 101.502 1.413l2.468-1.729 6.787 4.753c1.32.924 3.158.576 4.082-.744l-8.297-5.809L20 3.326zM3.58 5.68a1.851 1.851 0 110-3.702 1.851 1.851 0 010 3.702zm0 10.614a1.851 1.851 0 110-3.702 1.851 1.851 0 010 3.702z","fill":"#E2E8F0"}})])
          )
        }
      }
    